<template>
  <div class="my-3">
    <p class="mb-1 fw-bold">Published In Federal Register</p>
    <div class="d-flex justify-content-between">
      <div class="form-inline me-4">
        <label class="mr-2">Starting Date: </label>
        <input type="date" class="form-control" :value="statusDetails.start" @change="(event) => updateStartingDate(event.target.value)">
      </div>
      <div class="form-inline">
        <label class="mr-2">Ending Date:</label>
        <input type="date" class="form-control" :value="statusDetails.end" @change="(event) => updateEndingDate(event.target.value)">
      </div>
    </div>
  </div>
</template>

<script>
import {addOrUpdateParameter} from "@/helpers/urlParamsHelper";

export default {
  name: "PublishedInFederalReserve",


  computed: {
    statusDetails: function() {
      return this.$store.getters["search/getPublishedInFederalReserve"];
    }
  },

  methods: {

    // Sets the starting date for the latest update
    updateStartingDate(value) {
      this.$store.dispatch('search/updatePublishedInFederalReserveDateStart', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("publishedInFederalReserveStart", encodedParams);
    },

    // Sets the ending date for the latest update
    updateEndingDate(value) {
      this.$store.dispatch('search/updatePublishedInFederalReserveDateEnd', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("publishedInFederalReserveEnd", encodedParams);
    }

  }

}
</script>
